import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { GarantieWrapper } from "./CarigamiGarantie.styles";
var Garantie = function() {
    return /*#__PURE__*/ _jsx(GarantieWrapper, {
        href: "/conditions-garantie.htm",
        title: "Garantie meilleur prix",
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/ _jsx(UiLegacy.PixelIcon, {
            name: "garantie",
            label: "Garantie meilleur prix"
        })
    });
};
export { Garantie };
